import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMinus = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.5 12A1.5 1.5 0 0 1 5 10.5h14a1.5 1.5 0 0 1 0 3H5A1.5 1.5 0 0 1 3.5 12'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgMinus)
export default ForwardRef
